import * as stylex from "@stylexjs/stylex";
import { Info16 } from "icons/Info";
import React from "react";
import { ChartTooltip } from "../../components/tooltip";
import { colors } from "../../materials/consts.stylex";
export const Tooltip = ({ children, title, content })=>{
    const [hovered, setHovered] = React.useState(false);
    return <span className="xt0psk2 x117nqv4 x12klvby x1277o0a" onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)}>
      {children}&nbsp;
      <ChartTooltip title={title} content={content} placement="top" trigger={"manual"} visible={hovered} hideOnClick={false}>
        <span>
          <Info16 className="x1n2onr6 xcwszj3 x1rg5ohu x12klvby"/>
        </span>
      </ChartTooltip>
    </span>;
};
